var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"maintenance-message"}},[_vm._v(" Site is under scheduled maintenance untill 19 March 2021 3:00 AM IST ")])}
var staticRenderFns = []

export { render, staticRenderFns }